var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useLocale } from "./useLocale";
import { useRenderInput } from "./useRenderInput";
import { LocalizationProvider, TimePicker } from "@mui/x-date-pickers";
import * as React from "react";
import { PlainTimeAdapter } from "./PlainTimeAdapter";
export function PlainTimePicker(props) {
    const { value, onChange, label, locale: suppliedLocale, disabled } = props, renderInputProps = __rest(props, ["value", "onChange", "label", "locale", "disabled"]);
    const locale = useLocale(suppliedLocale);
    const renderInput = useRenderInput(renderInputProps);
    return (React.createElement(LocalizationProvider, { dateAdapter: PlainTimeAdapter, adapterLocale: locale },
        React.createElement(TimePicker, { label: label, value: value, disableMaskedInput: true, onChange: onChange, disabled: disabled, renderInput: renderInput })));
}
//# sourceMappingURL=PlainTimePicker.js.map